export const loadState = key => {
  try {
    const serializedState = localStorage.getItem(key)

    if (serializedState === null) {
      return undefined
    }

    return JSON.parse(serializedState)
  } catch (error) {
    return undefined
  }
}

export const saveState = key => state => {
  try {
    const serializedState = JSON.stringify(state)
    localStorage.setItem(key, serializedState)
  } catch (error) {
    console.error(error)
  }
}

export const deleteState = key => {
  try {
    localStorage.removeItem(key)
    return true
  } catch (error) {
    console.error(error)
    return false
  }
}
